import React from 'react';
import './ConfirmationModal.css';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    type?: 'danger' | 'warning' | 'info';
    isLoading?: boolean;
    children?: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    type = 'danger',
    isLoading = false,
    children
}) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'danger':
                return 'ri-delete-bin-line';
            case 'warning':
                return 'ri-alert-line';
            default:
                return 'ri-information-line';
        }
    };

    const getIconColor = () => {
        switch (type) {
            case 'danger':
                return '#ef4444';
            case 'warning':
                return '#f59e0b';
            default:
                return '#3b82f6';
        }
    };

    return (
        <div className="confirmation-modal-overlay" onClick={onClose}>
            <div className={`confirmation-modal confirmation-modal-${type}`} onClick={(e) => e.stopPropagation()}>
                <div className="confirmation-modal-header">
                    <div className="confirmation-modal-icon" style={{ color: getIconColor() }}>
                        <i className={getIcon()}></i>
                    </div>
                    <h3>{title}</h3>
                    <p>{message}</p>
                </div>
                
                {children && (
                    <div className="confirmation-modal-content">
                        {children}
                    </div>
                )}

                <div className="confirmation-modal-actions">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                        className="confirmation-modal-btn-secondary"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`confirmation-modal-btn-${type}`}
                    >
                        {isLoading ? (
                            <>
                                <i className="ri-loader-4-line rotating"></i>
                                Processing...
                            </>
                        ) : (
                            <>
                                <i className={getIcon()}></i>
                                {confirmText}
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
